import AvatarUpload from "./avatar-upload";


export default AvatarUpload;